import { useLook } from "../appearance";
import { SmallPeon } from "./SmallPeon";

/**
 * The peon stamp (shared/peon-stamp.ts): `name`'s peon drawn small in their look (SmallPeon) in a
 * one-pixel ink frame on parchment, `.peon-stamp` in src/styles.css. Worn by a closed note slip for
 * its author and by a board card for the peon the roulette wheel chose. No text beside it; `label`
 * is what a screen reader hears.
 */
export function PeonStamp({ name, label, className }: { name: string; label: string; className?: string }) {
  const look = useLook(name);
  return (
    <span class={className ? `peon-stamp ${className}` : "peon-stamp"} role="img" aria-label={label}>
      <SmallPeon look={look} />
    </span>
  );
}
